import React, { Component } from 'react'
import GetNavList from './NavList'
import GetSocialList from './SocialList'
import { Link } from 'gatsby'
import './Navigation.scss'
import logo from '../../../static/images/activelamp-logo.svg'

class Navigation extends Component {
  constructor(props) {
    super(props)
    this.state = { showNav: false, scrolled: false }
    this.handleClick = this.handleClick.bind(this)
  }

  componentDidMount() {
    document.addEventListener('scroll', this.debounce(this.storeScroll), {
      passive: true,
    })
    this.storeScroll()
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.debounce())
  }

  debounce = fn => {
    // This holds the requestAnimationFrame reference, so we can cancel it if we wish
    let frame

    // The debounce function returns a new function that can receive a variable number of arguments
    return (...params) => {
      // If the frame variable has been defined, clear it now, and queue for next frame
      if (frame) {
        cancelAnimationFrame(frame)
      }

      // Queue our function call for the next frame
      frame = requestAnimationFrame(() => {
        // Call our function and pass any params we received
        fn(...params)
      })
    }
  }

  storeScroll = () => {
    let scroll = window.scrollY
    let offset = 800

    if (scroll >= offset) {
      this.setState({ scrolled: true })
    } else {
      this.setState({ scrolled: false })
    }
  }

  handleClick() {
    this.setState(prevState => ({
      showNav: !prevState.showNav,
    }))
  }

  render() {
    const { children, config } = this.props

    const sidebar = (
      <div
        className={this.state.showNav ? 'sidenav show' : 'sidenav hidden'}
        aria-hidden={this.state.showNav ? false : true}
      >
        <a
          role="button"
          aria-label="Mobile Navigation Trigger"
          aria-expanded={this.state.showNav ? true : false}
          href="#"
          className="closebtn"
          onClick={ev => {
            ev.preventDefault()
            this.handleClick()
          }}
        >
          &times;
        </a>
        <div className="logo-img">
          <a href="/" rel="home" title="Home">
            <img
              src={logo}
              alt="ActiveLAMP Logo"
              title="ActiveLAMP Logo"
              id="logo"
              data-scroll-alt={logo}
            />
          </a>
        </div>
        <nav role="navigation" className="menu">
          <ul>
            {GetNavList(config).map((value, index) => {
              return (
                <li key={index}>
                  <Link
                    key={index}
                    activeClassName="active"
                    to={value.to}
                    alt={value.primaryText}
                  >
                    {value.primaryText}
                  </Link>
                </li>
              )
            })}
          </ul>
        </nav>
        <div className="social-block">
          <div className="social-container">
            {GetSocialList(config).map((value, index) => {
              return (
                <a
                  key={index}
                  href={value.to}
                  target="_blank"
                  alt={value.primaryText}
                >
                  {value.leftIcon}
                </a>
              )
            })}
          </div>
        </div>
      </div>
    )

    return (
      <div>
        <a
          role="button"
          aria-label="Mobile Navigation Trigger"
          href="#"
          aria-expanded={this.state.showNav ? true : false}
          className={
            this.state.scrolled
              ? 'navigation-button button primary circle scrolled'
              : 'navigation-button button primary circle unscrolled'
          }
          onClick={ev => {
            ev.preventDefault()
            this.handleClick()
          }}
        >
          <i className="fa fa-bars"></i>
        </a>
        {sidebar}
        <div
          className={'main ' + this.props.heroType}
          style={this.state.showNav ? { marginRight: '250px' } : {}}
        >
          {children}
        </div>
      </div>
    )
  }
}

export default Navigation
